import React, { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle?: any[];
  }
}

interface AdSenseSlotProps {
  slot: string;
  layout?: string;
  layoutKey?: string;
  format?: string;
  className?: string;
}

const AdSenseSlot: React.FC<AdSenseSlotProps> = ({ slot, layout, layoutKey, format = 'auto', className }) => {
  const insRef = useRef<HTMLModElement | null>(null);

  useEffect(() => {
    const publisherId = process.env.REACT_APP_ADSENSE_CLIENT;
    if (!publisherId) return;

    // 既にscriptが挿入済みかチェック
    if (!document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
      script.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(script);
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {
      // ignore
    }
  }, [slot]);

  const client = process.env.REACT_APP_ADSENSE_CLIENT || '';

  return (
    <div className={className}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout}
        data-ad-layout-key={layoutKey}
        ref={insRef as any}
      />
    </div>
  );
};

export default AdSenseSlot;


